import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../../utils';
import { partnerApiPath } from '../../apiPath';
import { partnerHttpClient } from '../../httpClient';

const PostSeedingProposalsRequestSchema = z
  .object({
    campaignId: z.union([z.string(), z.number()]),
    curatorIds: z.array(z.string().min(1)).min(1).max(100),
  })
  .describe('PostSeedingProposalsRequestSchema');

export type PostSeedingProposalsRequest = z.infer<typeof PostSeedingProposalsRequestSchema>;

const PostSeedingProposalsResponseDataSchema = z
  .object({
    successCount: z.number().int().min(0),
  })
  .describe('PostSeedingProposalsResponseDataSchema');

const PostSeedingProposalsResponseSchema = createApiResponseSchema(
  PostSeedingProposalsResponseDataSchema,
);

export type PostSeedingProposalsResponse = z.infer<typeof PostSeedingProposalsResponseSchema>;

export const postSeedingProposals = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(PostSeedingProposalsRequestSchema),
    async ({ campaignId, curatorIds }: PostSeedingProposalsRequest) =>
      executeStandardRequest(async () =>
        partnerHttpClient.post<PostSeedingProposalsResponse>(
          partnerApiPath.postSeedingProposals(campaignId),
          { curatorIds },
        ),
      ),
    validateApiResponse(PostSeedingProposalsResponseSchema),
  ),
);
